<script setup lang="ts">
import iconService from '~/assets/scss/static/nav/nav-dropdown@3x.png'
import iconBusiness from '~/assets/scss/static/nav/nav-qrcode@3x.png'
import logoImg from '~/assets/scss/static/logo/logo.png'

const { getResourceImage } = useSystemResources()
const fallbackBusinessQrcode = useOssImage('/img/group.png')
const businessQrcode = computed(
  () => getResourceImage('business_qr_code') || fallbackBusinessQrcode,
)

function contactService() {
  // window.open('https://wpa1.qq.com/gl51caMq?_type=wpa&qidian=true', '_blank')
  window.open('https://work.weixin.qq.com/kfid/kfc24035347c7421497', '_blank')
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
</script>
 
<template>
  <aside class="float-nav">
    <div class="float-nav__panel">
      <button type="button" class="float-nav__item" @click="contactService">
        <img class="float-nav__icon" :src="iconService" alt="" />
        <span>联系<br />客服</span>
      </button>

      <ElPopover placement="left" :width="180" trigger="hover">
        <template #reference>
          <button type="button" class="float-nav__item">
            <img class="float-nav__icon" :src="iconBusiness" alt="" />
            <span>商务<br />合作</span>
          </button>
        </template>
        <div class="float-nav__popover">
          <img :src="businessQrcode" alt="商务合作二维码" class="float-nav__qrcode" />
          <p>微信扫码商务合作</p>
        </div>
      </ElPopover>
    </div>

    <button type="button" class="float-nav__logo" @click="scrollToTop">
      <img :src="logoImg" alt="返回顶部" />
    </button>
  </aside>
</template>

<style scoped lang="scss">
$float-orange: #FF7A3C;

.float-nav {
  position: fixed;
  right: 18px;
  top: 50%;
  z-index: 120;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  &__panel {
    width: 48px;
    height: 154px;
    padding: 9px 4px 10px;
    border: 1px solid #fff;
    border-radius: 999px;
    background: #feebe1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08), 0 14px 24px rgba(255, 106, 0, 0.1);
    box-sizing: border-box;
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    width: 100%;
    min-height: 62px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    color: #4f5966;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.18;
    transition: color 0.2s, transform 0.2s;

    &:hover {
      color: $float-orange;
      transform: translateY(-1px);
    }

    & + & {
      position: relative;
      margin-top: 6px;
      padding-top: 12px;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        width: 20px;
        height: 1px;
        transform: translateX(-50%);
        background: rgba(255, 255, 255, 0.85);
      }
    }
  }

  &__icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  &__logo {
    width: 48px;
    height: 48px;
    padding: 0;
    border: 1px solid #fff;
    border-radius: 50%;
    background: #feebe1;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08), 0 10px 18px rgba(255, 106, 0, 0.16);
    cursor: pointer;
    overflow: hidden;
    transition: transform 0.2s;

    &:hover {
      transform: translateY(-2px);
    }

    img {
      display: block;
      width: 36px;
      height: 36px;
      margin: 6px auto 0;
      object-fit: cover;
      object-position: left center;
      border-radius: 50%;
    }
  }

  &__popover {
    text-align: center;

    p {
      margin: 8px 0 0;
      font-size: 12px;
      color: #666;
    }
  }

  &__qrcode {
    width: 140px;
    height: 140px;
    display: block;
    margin: 0 auto;
    border-radius: 8px;
  }
}

@media (max-width: 768px) {
  .float-nav {
    right: 10px;

    &__panel {
      width: 46px;
      height: 150px;
      padding: 9px 4px 10px;
    }

    &__item {
      font-size: 10px;
    }

    &__icon {
      width: 20px;
      height: 20px;
    }

    &__logo {
      width: 46px;
      height: 46px;

      img {
        width: 34px;
        height: 34px;
        margin-top: 5px;
      }
    }
  }
}
</style>
